import { AlertTriangle } from "lucide-react";

interface Props {
  show: boolean;
  titulo: string;
  descricao: string;
  textoBotaoConfirmar?: string;
  onConfirmar: () => void;
  onCancelar: () => void;
  loading?: boolean;
}

const ConfirmacaoModal = ({
  show,
  titulo,
  descricao,
  textoBotaoConfirmar = "Confirmar",
  onConfirmar,
  onCancelar,
  loading = false,
}: Props) => {
  if (!show) return null;

  return (
    <div className="painel-modal-overlay" onClick={onCancelar}>
      <div className="painel-modal-card" onClick={(e) => e.stopPropagation()}>
        <div className="painel-modal-icon">
          <AlertTriangle size={28} />
        </div>
        <h3 className="painel-modal-titulo">{titulo}</h3>
        <p className="painel-modal-descricao">{descricao}</p>
        <div className="painel-modal-acoes">
          <button
            className="painel-btn painel-btn-ghost"
            onClick={onCancelar}
            disabled={loading}
          >
            Cancelar
          </button>
          <button
            className="painel-btn painel-btn-danger"
            onClick={onConfirmar}
            disabled={loading}
          >
            {loading ? "Aguarde…" : textoBotaoConfirmar}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmacaoModal;
